import { ReactElement } from 'react';
import { Switch as BaseSwitch, SwitchProps } from '@mui/material';
import collect from 'collect.js';
import { styled } from '@mui/material/styles';

interface Props extends SwitchProps {
  onStateText?: string;
  offStateText?: string;
}

const StyledSwitch = styled(BaseSwitch)(({ textstyles }: { textstyles: object }) => ({
  width: '56px',
  height: '26px',
  padding: '0px',
  '& .MuiSwitch-switchBase': {
    color: '#818181',
    padding: '1px',
    transitionDuration: '300ms',
    '&.Mui-checked': {
      color: '#69CE8C !important',
      transform: 'translateX(28px) !important',
      '& + .MuiSwitch-track': {
        backgroundColor: '#23bf58',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    color: 'white',
    width: '20px',
    height: '20px',
    margin: '2px',
    marginLeft: '3px',
  },
  '& .MuiSwitch-track': {
    borderRadius: '16px',
    backgroundColor: '#818181',
    opacity: '1 !important',
    transition: 'background-color 500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
    ...textstyles,
  },
  '& .MuiSwitch-checked': {
    color: '#69CE8C !important',
    transform: 'translateX(28px) !important',
  },
}));

export default function Switch(props: Props): ReactElement {
  const { onStateText, offStateText, checked, ...rest } = props;

  const textStyles = collect({})
    .when(Boolean(onStateText) && checked, (collection) =>
      collection.merge({
        '&:after': {
          color: 'white',
          fontSize: '10px',
          position: 'absolute',
          top: '5px',
          left: '6px',
          content: `"${onStateText}"`,
        },
      }),
    )
    .when(Boolean(offStateText) && !checked, (collection) =>
      collection.merge({
        '&:before': {
          color: 'white',
          fontSize: '10px',
          position: 'absolute',
          top: '5px',
          right: '6px',
          content: `"${offStateText}"`,
        },
      }),
    )
    .all();

  return <StyledSwitch textstyles={textStyles} checked={checked} {...rest} />;
}
